export default {
  entityName: "Currency",
  apiEndpoint: "/master/currencies",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "Currency Name", sortable: true },
    { key: "code", label: "Code", sortable: true, class: () => "font-mono font-bold" },
    { key: "symbol", label: "Symbol", sortable: true },
    { key: "decimals", label: "Decimals", sortable: true },
    { key: "isBase", label: "Base Currency", sortable: true, formatter: (val) => val ? "Yes" : "No" },
  ],
  fields: [
    { name: "name", label: "Currency Name", type: "text", required: true, placeholder: "e.g. United States Dollar" },
    { name: "code", label: "Currency Code", type: "text", required: true, uppercase: true, placeholder: "e.g. USD" },
    { name: "symbol", label: "Symbol", type: "text", required: true, placeholder: "e.g. $" },
    { name: "decimals", label: "Decimal Places", type: "number", required: true, default: 2, min: 0, max: 6 },
    { name: "isBase", label: "Set as Base Currency", type: "checkbox", default: false },
    
    // Advanced properties wrapped in Accordion
    { name: "cashRoundingPrecision", label: "Cash Rounding Precision", type: "number", default: 0.01, advanced: true },
    { name: "roundingMethod", label: "Rounding Method", type: "select", options: ["HALF_UP", "HALF_EVEN", "ROUND_UP", "ROUND_DOWN"], default: "HALF_UP", advanced: true },
    { name: "displayFormat", label: "Display Format", type: "text", default: "{symbol}{amount}", advanced: true },
    { name: "effectiveFrom", label: "Effective From", type: "date", advanced: true },
    { name: "effectiveTo", label: "Effective To", type: "date", advanced: true },
  ],
  filters: [],
  workflow: {
    type: "currency_approval",
    enabled: true,
  },
};
